<template>
    <div class="checkbox-input">
        <button v-on:click="onClick" type="button" class="btn btn-outline-primary" data-mdb-ripple-color="dark">
            <div class="d-flex justify-content-between align-items-center">
                <input class="form-check-input me-4" type="checkbox" v-model="state"/>
                <span>
                    {{ text }}
                </span>
            </div>
        </button>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    data() {
        return {
            state: false,
        }
    },
    props: {
        text: {},
        value: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onClick() {
            this.state = !this.state
            this.$emit('input', !this.value)
        },
    },
    created() {
        this.state = this.value
    } 
})
</script>

<style>
    .checkbox-input .form-check-input[type=checkbox] {
        margin: 0px;
    }
</style>